import { Collapse } from '@mui/material';
import { SearchResultsSummary } from 'src/components';

import { isNativePlatform } from '../../config';
import AllSelectedFilters from '../SessionSearchbox/AllSelectedFilters';
import Multiselect from '../SessionSearchbox/Multiselect';
import MultiselectWithCounter from '../SessionSearchbox/MultiselectWithCounter';
import {
  Wrapper,
  Field,
  PracticePlanBasicFields,
  ClearButton,
  ClearIcon,
  ClearLabel,
  SearchResultsButton,
  SearchResultsIcon,
  SearchResultsLabel,
  SearchResultsExpand,
  SimplifiedSearchArea,
  SimplifiedSearchInput,
} from '../SessionSearchbox/styles/searchboxStyles';
import usePracticePlanSearch from './usePracticePlanSearch';

const EMPTY_LOCKED_KEYS = new Set<string>();

export const PracticePlanSearchbox: React.FC<{
  results?: number;
  searchPending: boolean;
}> = ({
  results = undefined,
  searchPending = false,
}) => {
  const {
    options,
    searchLink,
    aggregatedOptions,
    values,
    onChange,
    onClearFilter,
    onClearAllFilters,
    onPhraseConfirm,
    displayFilters,
    toggleDisplayFilters,
  } = usePracticePlanSearch();

  const practicePlanFields = (
    <PracticePlanBasicFields>
      <Field area="tag">
        <Multiselect
          label="Wyszukaj frazę"
          id="practice-plan-tags-and-phrase-select"
          name="title"
          aggregatedOptions={aggregatedOptions}
          aggregatedValues={values.aggregated}
          tagValues={values.tag}
          onTagsChange={onChange.tag}
          onAddForeignValue={() => {}}
          phrase={values.phrase}
          onPhraseChange={onChange.phrase}
          onPhraseConfirm={onPhraseConfirm}
        />
      </Field>
      <Field area="difficulty">
        <MultiselectWithCounter
          label="Poziom trudności"
          id="practice-plan-difficulty-select"
          name="difficulty"
          options={options.difficulty}
          values={values.difficulty}
          onChange={onChange.difficulty}
          noTextInput
        />
      </Field>
      <Field area="actions">
        <SearchResultsButton to={searchLink} $mobile={isNativePlatform}>
          <SearchResultsLabel>Pokaż wyniki</SearchResultsLabel>
          <SearchResultsIcon />
        </SearchResultsButton>
      </Field>
    </PracticePlanBasicFields>
  );

  return (
    <>
      <Wrapper>
        <Collapse in={isNativePlatform ? displayFilters : true}>
          {practicePlanFields}
        </Collapse>
        {isNativePlatform && !displayFilters && (
          <SimplifiedSearchArea>
            <SimplifiedSearchInput>
              <Field area="tag">
                <Multiselect
                  label="Wyszukaj frazę"
                  id="practice-plan-tags-and-phrase-select-mobile"
                  name="title"
                  aggregatedOptions={aggregatedOptions}
                  aggregatedValues={values.aggregated}
                  tagValues={values.tag}
                  onTagsChange={onChange.tag}
                  onAddForeignValue={() => {}}
                  phrase={values.phrase}
                  onPhraseChange={onChange.phrase}
                  onPhraseConfirm={onPhraseConfirm}
                />
              </Field>
            </SimplifiedSearchInput>
            <SearchResultsExpand onClick={toggleDisplayFilters} $mobile={isNativePlatform}>
              <SearchResultsLabel>Pokaż filtry</SearchResultsLabel>
            </SearchResultsExpand>
          </SimplifiedSearchArea>
        )}
      </Wrapper>
      <SearchResultsSummary
        results={results ?? NaN}
        pending={searchPending}
        showIf={results != null}
      />
      <AllSelectedFilters
        filters={values.all}
        lockedFilterKeys={EMPTY_LOCKED_KEYS}
        hideLockedFilterChips={false}
        onClearFilter={onClearFilter}
        clearAllButton={(
          <ClearButton onClick={onClearAllFilters}>
            <ClearIcon />
            <ClearLabel>Wyczyść wszystko</ClearLabel>
          </ClearButton>
        )}
      />
    </>
  );
};
